// Termin wpłaty zaliczki rezerwacji z panelu (FAZA F, F.6, Premium). Pracownik ustawia go przy
// wysyłce linku do zaliczki; bez wpłaty do terminu serwer anuluje rezerwację (sweep nieopłaconych
// rezerwacji, Login/backend/lib/terminWplaty.js). Tu tylko zakres i wartość domyślna pola.
//
// Zakres jak na serwerze, z zapasem: serwer przyjmuje termin co najmniej 30 minut od teraz, a pole
// proponuje co najmniej godzinę, żeby pracownik, który chwilę czeka z kliknięciem, nie dostał
// odmowy. Najwyżej 30 dni. Termin wypada najpóźniej o 22:00 dnia przed rozpoczęciem rezerwacji:
// sweep chodzi co godzinę, a rezerwacji w dniu startu już nie anuluje, więc termin o 23:59 nie
// byłby egzekwowany (serwer odrzuca późniejszy).

export const TERMIN_DOMYSLNY_GODZIN = 48;
export const MIN_GODZIN_DOMYSLNYCH = 1;
export const MAX_GODZIN_DOMYSLNYCH = 720;

const MINUTA = 60 * 1000;
const GODZINA = 60 * MINUTA;
const MAX_DO_TERMINU = 30 * 24 * GODZINA;
// Zapas przed północą dnia rozpoczęcia, jak na serwerze (ZAPAS_PRZED_STARTEM_MS).
const ZAPAS_PRZED_STARTEM = 2 * GODZINA;

const doMinuty = (ms) => Math.ceil(ms / MINUTA) * MINUTA;

/**
 * Północ dnia rozpoczęcia rezerwacji w czasie lokalnym albo null. `start_date` z API przychodzi jako
 * znacznik czasu („2026-11-09T23:00:00.000Z” dla 10 listopada), więc dzień bierzemy z czasu
 * lokalnego, tak jak utils/contract.js#parseYMD.
 */
export function poczatekRezerwacji(startDate) {
  if (!startDate) return null;
  const m = typeof startDate === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(startDate) : null;
  const d = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(startDate);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Najwcześniejszy i najpóźniejszy termin albo null, gdy rezerwacja zaczyna się zbyt szybko. */
export function zakresTerminu({ teraz = new Date(), startDate = null } = {}) {
  const min = doMinuty(teraz.getTime() + GODZINA);
  let max = Math.floor((teraz.getTime() + MAX_DO_TERMINU) / MINUTA) * MINUTA;
  const start = poczatekRezerwacji(startDate);
  if (start) max = Math.min(max, start.getTime() - ZAPAS_PRZED_STARTEM);
  if (max < min) return null;
  return { min: new Date(min), max: new Date(max) };
}

/** Domyślny czas na wpłatę z ustawień: liczba całkowita w zakresie, inaczej 48 godzin. */
export function godzinyDomyslne(wartosc) {
  const n = Number(wartosc);
  return Number.isInteger(n) && n >= MIN_GODZIN_DOMYSLNYCH && n <= MAX_GODZIN_DOMYSLNYCH ? n : TERMIN_DOMYSLNY_GODZIN;
}

/** Termin domyślny: teraz plus czas z ustawień, przycięty do zakresu. Null, gdy zakresu nie ma. */
export function domyslnyTermin({ teraz = new Date(), godziny = TERMIN_DOMYSLNY_GODZIN, startDate = null } = {}) {
  const zakres = zakresTerminu({ teraz, startDate });
  if (!zakres) return null;
  const cel = doMinuty(teraz.getTime() + godzinyDomyslne(godziny) * GODZINA);
  return new Date(Math.min(zakres.max.getTime(), Math.max(zakres.min.getTime(), cel)));
}

const dwie = (n) => String(n).padStart(2, '0');

/** Wartość pola `datetime-local` (czas lokalny, bez sekund). */
export function doPolaDatetime(data) {
  if (!(data instanceof Date) || Number.isNaN(data.getTime())) return '';
  return `${data.getFullYear()}-${dwie(data.getMonth() + 1)}-${dwie(data.getDate())}T${dwie(data.getHours())}:${dwie(data.getMinutes())}`;
}

/** Data z pola `datetime-local` (czas lokalny) albo null. */
export function zPolaDatetime(tekst) {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(String(tekst || ''));
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]));
  return Number.isNaN(d.getTime()) || d.getMonth() !== Number(m[2]) - 1 ? null : d;
}

/** Czy termin z pola mieści się w zakresie. */
// Ile godzin po przypomnieniu rezerwacja z widgetu zostanie anulowana, gdy po usunięciu terminu
// wraca do reguły widgetu (`widget_cancel_hours` z serwera = okno auto-anulowania). Ta sama liczba,
// którą podaje klientowi mail przypomnienia (server.js#sweepUnpaidWidgetReservations, `hoursLeft`):
// połowa okna, co najmniej 1. Bez okna null: rezerwacja nie wraca do żadnej reguły.
export function godzinyPoPrzypomnieniuWidgetu(okno) {
  const n = Number(okno);
  if (okno === null || okno === undefined || okno === '' || !Number.isFinite(n) || n <= 0) return null;
  return Math.max(1, Math.round(n / 2));
}

export function terminWZakresie(data, zakres) {
  return !!(data && zakres && data.getTime() >= zakres.min.getTime() && data.getTime() <= zakres.max.getTime());
}
